

<mat-form-field class="example-full-width" [id]="activity.inputControlID"  floatLabel="never">

    <input matInput autocomplete="off" [attr.width]="activity.controlWidth"
        [attr.maxlength]="activity.maxLength" name="ans"  [formControl]="activityControl"
        [required]="activity.isRequired" [placeholder]="activity.hint" >

    <mat-error *ngIf="activityControl.hasError('required')">
        {{'Required' | translate}}*
    </mat-error>
    <mat-error *ngIf="activityControl.hasError('pattern')">
      {{'UrlError' | translate}}
    </mat-error>
    <mat-error *ngIf="activityControl.hasError('max')">
        {{'MaxValueErrorMsg' | translate}} {{activity.maxValue}}
    </mat-error>

    <mat-error *ngIf="activityControl.hasError('min')">
        {{'MinValueErrorMsg' | translate}} {{activity.minValue}}
    </mat-error>




  </mat-form-field>
